import { makeAutoObservable } from "mobx";
import { Availability } from "./Availability";
import { Email } from "./Email";
/**
 * Observable holder for the consent-withdrawal form's email input. The field is
 * optional here (the user withdraws consent by whichever channel they
 * remember), so only the `InvalidEmail` reason is ever surfaced — an empty
 * value is valid.
 */
export class WithdrawalEmailModel {
    constructor(initialValue) {
        this.value = "";
        this.value = initialValue;
        makeAutoObservable(this);
    }
    get email() {
        return Email.create(this.value);
    }
    get availability() {
        // Treat an empty value as valid (the field is optional); Email flags empty
        // as InvalidEmail too, which is only correct where an address is required.
        return Availability.boolean({
            InvalidEmail: !this.email.isEmpty && !this.email.isValid,
        });
    }
}
